<template>
  <div class="list-table">
    <div class="list-table__filter">
      <el-button
        type="primary"
        icon="yun-iconfont icon-add"
        @click="handleAdd"
      >
        新增
      </el-button>
      <el-button
        type="primary"
        icon="yun-iconfont icon-upload"
        @click="handleImport('import')"
      >
        批量管控
      </el-button>
      <el-button
        class="to-right"
        type="primary"
        icon="yun-iconfont icon-page"
        @click="handleImport('catLog')"
      >
        批量管控日志
      </el-button>
      <el-button
        class="to-right"
        icon="yun-iconfont icon-page"
        type="primary"
        @click="handleAllLog"
      >
        全局日志
      </el-button>
      <el-button
        class="to-right"
        type="primary"
        icon="yun-iconfont icon-download"
        @click="handleOutImport('export')"
      >
        导出人员
      </el-button>
    </div>
    <el-table
      v-loading="loading"
      class="list-table__main"
      :data="list"
      border
      highlight-current-row
    >
      <el-table-column
        v-for="(item, index) in TABLE_COLUMN"
        :key="index"
        v-bind="item"
      >
        <template v-if="item.showTip" slot="header">
          <span style="margin-right: 5px;">{{ item.label }}</span>
          <el-tooltip
            class="item"
            effect="dark"
            :content="item.tipText"
            placement="top-start"
          >
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <div v-if="item.prop === 'action'">
            <el-button
              type="text"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              @click="handleView(scope.row)"
            >
              详情
            </el-button>
            <el-button
              type="text"
              @click="handleEmpower(scope.row)"
            >
              授权
            </el-button>
            <el-button
              type="text"
              @click="handleLog(scope.row)"
            >
              日志
            </el-button>
            <el-button
              type="text"
              style="color: #F53F3F"
              @click="handleOpenDleOnline(scope.row)"
            >
              踢下线
            </el-button>
          </div>
          <span v-else-if="item.prop === 'controlSystem'">
            <div v-for="i in scope.row.controlSystem.map(item => systemLabelMap[item])" :key="i">{{ i }}</div>
          </span>
          <span v-else-if="item.prop === 'equipmentType'">
            {{ handleDeviceType(scope.row) }}
          </span>
          <span v-else>
            {{ (item.formatter ? item.formatter(scope.row) : scope.row[item.prop]) || "-" }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <form-dialog
      :id="currentId"
      :visible.sync="isFormDialogVisible"
      :mode="dialogMode"
      :system-options="systemOptions"
      @ok="$emit('refresh')"
    />
    <el-dialog
      v-if="showImport"
      :visible.sync="showImport"
      :title="title"
      :width="width"
    >
      <import-file v-if="importType==='import'" @closeDialog="closeDialog" />
      <CatExportLog v-else-if="importType==='export'" @closeDialog="closeDialog" />
      <cat-import-log v-else @closeDialog="closeDialog" />
    </el-dialog>

    <el-dialog
      :visible.sync="confirmVisible"
      title="确认踢下线？"
      width="480px"
    >
      <el-input
        v-model="dleOnlineText"
        placeholder="请输入踢下线原因"
        type="text"
      />
      <span slot="footer" class="dialog-footer">
        <el-button :disabled="delOnlineLoading" @click="confirmVisible = false">取 消</el-button>
        <el-button
          type="primary"
          :disabled="delOnlineLoading"
          @click="handleOnline"
        >确 定</el-button>
      </span>
    </el-dialog>
    <EmpowerDialog
      v-model="empowerVisible"
      :current-row="currentEmpower"
      @refresh="$emit('refresh')"
    />
  </div>
</template>

<script>
// import dayjs from 'dayjs';
/* eslint-disable no-param-reassign */

import { searchFormFilter } from '@/utils';
import { controlOnlineOut } from '@/api/userControl';
import { upsertOutImport } from '@/api/operateControl';
import { localStorageGet } from '@/utils/localStorage';
import { USER } from '@/constant/storage';
import FormDialog from './FormDialog.vue';
import { TABLE_COLUMN } from '../constant';
import ImportFile from './ImportFile.vue';
import CatImportLog from './CatImportLog.vue';
import CatExportLog from './CatExportLog.vue';
import EmpowerDialog from './EmpowerDialog.vue';

export default {
  name: 'ListTable',
  components: {
    FormDialog,
    ImportFile,
    CatImportLog,
    CatExportLog,
    EmpowerDialog,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    systemOptions: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      TABLE_COLUMN,
      dialogMode: '',
      isFormDialogVisible: false,
      currentId: '',
      showImport: false,
      importType: 'import',
      width: '560px',
      title: '管控信息导入',
      confirmVisible: false,
      dleOnlineText: '',
      currentRow: {},
      delOnlineLoading: false,
      empowerVisible: false,
      currentEmpower: {},
    };
  },
  computed: {
    systemLabelMap() {
      const res = {};
      this.systemOptions.forEach((item) => {
        res[item.systemCode] = item.name;
      });
      return res;
    },
  },
  methods: {
    handleDeviceType(data) {
      let laptop = 0; let desktop = 0; let computer = 0;
      data.details.forEach((item) => {
        if (item.controlType === 'EQUIPMENT') {
          if (item.equipmentType === 'ALLOTMENT_LAPTOP') {
            laptop += 1;
          }
          if (item.equipmentType === 'ALLOTMENT_DESKTOP') {
            desktop += 1;
          }
          if (item.equipmentType === 'OWN_COMPUTER') {
            computer += 1;
          }
        }
      });
      const arr = [];
      if (laptop > 0) {
        arr.push(`配发:${laptop}`);
      }
      if (desktop > 0) {
        arr.push(`台式:${desktop}`);
      }
      if (computer > 0) {
        arr.push(`自有:${computer}`);
      }
      const str = arr.join(' ');
      return str;
    },
    handleImport(val) {
      this.importType = val;
      if (val === 'import') {
        this.width = '560px';
        this.title = '管控信息导入';
      } else if (val === 'export') {
        this.width = '70%';
        this.title = '管控信息导出';
      } else {
        this.width = '70%';
        this.title = '管控信息导入日志';
      }
      this.showImport = true;
    },
    // 导出
    async handleOutImport(val) {
      try {
        let { companyId, unifyName } = this.form;
        if (companyId === '') {
          companyId = null;
        }
        if (unifyName === '') {
          unifyName = null;
        }
        const userInfo = localStorageGet(USER) || {};
        const param = {
          companyId, unifyName, needConfigDetail: true, clientCode: 'new_workbench', ...this.form,
        };
        const tempParam = searchFormFilter(param);
        const data = {
          businessType: 'CONTROL_USER_EXPORTER',
          userName: userInfo.realName,
          userId: userInfo.userId,
          reqParam: { ...tempParam },
        };
        await upsertOutImport(data, { sort: 'update_time__DESC' });
        this.handleImport(val);
      } finally {
        // this.importLoading = false;
      }
    },
    closeDialog(val) {
      if (val.needRefresh) {
        this.$emit('refresh');
      }
      this.showImport = false;
    },
    handleLog(row) {
      this.$router.push({
        path: '/userCenter/operationControl/personLog',
        query: {
          unifyId: row.unifyId,
        },
      });
    },
    handleAllLog() {
      this.$router.push({
        path: '/userCenter/operationControl/log',
      });
    },

    handleAdd() {
      this.currentId = '';
      this.dialogMode = 'ADD';
      this.isFormDialogVisible = true;
    },
    handleEdit(row) {
      this.currentId = row.id;
      this.dialogMode = 'EDIT';
      this.isFormDialogVisible = true;
    },
    handleView(row) {
      this.currentId = row.id;
      this.dialogMode = 'VIEW';
      this.isFormDialogVisible = true;
    },
    handleOpenDleOnline(row) {
      this.confirmVisible = true;
      this.currentRow = row;
      this.dleOnlineText = '';
    },
    async handleOnline() {
      try {
        const params = { unifyIds: [this.currentRow.unifyId], clientCode: 'new_workbench', reason: this.dleOnlineText };
        this.delOnlineLoading = true;
        await controlOnlineOut(params);
        this.$message.success('操作成功');
        this.confirmVisible = false;
      } finally {
        this.delOnlineLoading = false;
      }
    },
    // 授权
    handleEmpower(row) {
      this.currentEmpower = row;
      this.empowerVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-table {
  &__filter {
    margin-bottom: 16px;
  }
}
.to-right{
  float: right;
}
</style>
